import { Button, Space, Tabs, Tooltip, notification } from "antd";
import { useEffect, useState } from "react";
import API_SERVICE from "shared/services/api-service";
import giftIcon from "../../../../../assets/images/gift.svg";
import info from "../../../../../assets/images/info.svg";
import Login from "./Login";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";

interface ILoginTabs {
    setIsLoading: any;
    leadData: any;
    updateCase: any;
    getRedirectURLLink: any;
    getCashETriggerSMSLink: any;
    callbackReqDoc: any;
    callbackAdditionalField: any;
    setShowRequirementDocs: any;
    setSelectedLander: any;
    setSelectedLender:any;
    selectedLender:any,
    setAdditionalFields: any;
    setCurrLenderId: any;
    setCurrLeadId: any;
    setShowAdditionalFields: any;
    setIsLoginListDecisioning: any;
    isLoginListDecisioning: any;
    submitTask: any;
    getTaskData: any;
    getLenderAdditonalField: any;
    lenderNextHandler: any;
    loading: any;
    getNextTask: any;
    setCallbackReqDoc: any;
    setProductPlanName:any
    productPlanName:any;
    setProductPlanId:any;
    productPlanId:any;
    annualFee:any;
    setAnnualFee:any
}

const LoginTabs: React.FC<ILoginTabs> = (props: ILoginTabs) => {
    const {
        setIsLoading,
        leadData,
        updateCase,
        getRedirectURLLink,
        getCashETriggerSMSLink,
        callbackReqDoc,
        callbackAdditionalField,
        setShowRequirementDocs,
        setSelectedLander,
        setSelectedLender,
        selectedLender,
        setAdditionalFields,
        setCurrLenderId,
        setCurrLeadId,
        setShowAdditionalFields,
        setIsLoginListDecisioning,
        isLoginListDecisioning,
        submitTask,
        getTaskData,
        getLenderAdditonalField,
        lenderNextHandler,
        loading,
        getNextTask,
        setCallbackReqDoc,
        setProductPlanName,
        productPlanName,
        setProductPlanId,
        productPlanId,
        annualFee,
        setAnnualFee
    } = props;
    const [descisioningDetail, setListDescisioningDetail] = useState([] as any);
    const [isLoginTabsListDecisioning, setIsLoginTabsListDecisioning] = useState(false);
    const [lenderListInsurer, setLenderListInsurer] = useState([] as any);
    const [lenders, setLenders] = useState([] as any);
    const [ip, setIP] = useState(undefined);
    const [lendersData, setLendersData] = useState([] as any);
    const [loginTabkey, setLoginTabkey] = useState(leadData?.journeyConfigResponseList?.at(0)?.journeyId);
    const { appColors }: any = useSelector((state: RootState) => state.common);
    const { tenantInfo }: any = useSelector((state: RootState) => state.tenant);


    useEffect(() => {
        if (isLoginListDecisioning) {
            if(tenantInfo?.businessProductType === "INSURANCE") {
                getLenders();
            } else {
                listDecisioning();
            }
            setIsLoginListDecisioning(false);
        }
    }, [isLoginListDecisioning])

    const listDecisioning = () => {
        setIsLoading(true);
        let tmpId = leadData?.journeyConfigResponseList?.map((item: any) => {
            return item?.journeyId
        })
        API_SERVICE.listDecisioning(leadData?.caseDetails?.caseId, false, '', tmpId)
            .then(({ data }) => {
                setLoginTabkey(data?.payload?.journeyWiseDecisioningDataList?.at(0)?.journeyId);
                setListDescisioningDetail(data?.payload?.journeyWiseDecisioningDataList);
                getLenders();
            })
            .catch((e: any) => {
                notification.error({ message: API_SERVICE?.handleErrors(e) });
            }).finally(() => setIsLoading(false))
    };

    const getIPData = async () => {
        const { data } = await API_SERVICE.getIPData();
        setIP(data.ip)
        return data.ip
    };
    
    const getLenders = async (isRefresh: boolean = false) => {
        setIsLoading(true);

        let param: any = {
            status: "Active",
            loanProductId: leadData?.loanProductId,
            caseId:leadData?.caseDetails?.caseId,
            pageNo: 1,
            pageSize: 200,
        }

        if(leadData?.loanType==="Credit Card"){
            param = {
                ...param,
                systemIp: ip ?? await getIPData(),
                source: "CASE",
                refreshAggregatorOffer: isRefresh
            }
        }

        API_SERVICE.getLenders(param)
            .then(({ data }) => {
                if (data?.payload?.content) {
                    const datas = data?.payload?.content;
                    setLendersData(datas)
                    // getProductsPlans()
                    let payload1 = {
                        lenderIds: datas?.map((lender: any) => lender?.lenderInfoId)?.join(","),
                        loanProductId: leadData?.loanProductId,
                        status: "ACTIVE"
                      };
                      API_SERVICE.getLenderListInsurer(payload1)
                        .then(({ data }) => setLenderListInsurer(data?.payload))
                        const tmpCardArray = [] as any;
                         let tmpDecisionData = datas.filter((item)=>item?.lenderSubProductOfferDetailsList != undefined || item?.lenderSubProductOfferDetailsList != null)
                        tmpDecisionData?.forEach((record) => {
                            const fees = record?.lenderSubProductOfferDetailsList?.map((item) => {
                            const offerDetail = item?.aggregatorOfferDetails?.aggregatorOfferDetails?.[0]?.offerDetails;
                            return {
                                planId: item.productPlanId,
                                annualFee: offerDetail?.annual_fee,
                            };
                            });
                            tmpCardArray.push(fees)     
                        });
                        setAnnualFee(tmpCardArray);
                }
            })
            .catch((e: any) => {
                notification.error({ message: API_SERVICE?.handleErrors(e) });
            })
            .finally(() => setIsLoading(false));
    };

    const listData = (decisionData: any, tmpLendersData: any = lendersData) => {
        const tmp = [...decisionData];
        for (let i = tmpLendersData?.length - 1; i >= 0; i--) {
            for (let j = 0; j < tmp?.length; j++) {
                if (
                    tmpLendersData[i] &&
                    tmpLendersData[i]?.lenderInfoId === tmp[j]?.lenderInfoId
                ) {
                    tmpLendersData?.splice(i, 1);
                    const findLender =
                        leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
                            (item) =>
                                item?.lenderInfoId == decisionData[j]?.lenderInfoId
                        );
                    tmp[j] = { ...tmp[j], ...findLender };
                }
            }
        }

        const allLenders = [...tmp, ...tmpLendersData];

        allLenders.sort((a: any, b: any) =>
            b.maxLoanAmount - a.maxLoanAmount
        );

        allLenders.sort((a: any, b: any) => {
            const isDocUploadedA =
                a?.submissionType != "API" ||
                (a?.submissionType == "API" && a?.allDocumentUploaded) ||
                ["REJECTED", "PENDENCY", "WITHDRAWN"].includes(a?.status);
            const isLoggedA =
                isDocUploadedA &&
                [
                    "LOGGED",
                    "SANCTIONED",
                    "DISBURSED",
                    "REJECTED",
                    "PENDENCY",
                    "WITHDRAWN",
                ].includes(a?.status);

            const isDocUploadedB =
                b?.submissionType != "API" ||
                (b?.submissionType == "API" && b?.allDocumentUploaded) ||
                ["REJECTED", "WITHDRAWN", "PENDENCY"].includes(b?.status);
            const isLoggedB =
                isDocUploadedB &&
                [
                    "LOGGED",
                    "SANCTIONED",
                    "DISBURSED",
                    "REJECTED",
                    "PENDENCY",
                    "WITHDRAWN",
                ].includes(b?.status);

            return isLoggedA === isLoggedB ? 0 : isLoggedA ? -1 : 1;
        });
        return allLenders;
    }

    const onPublishCW = (journeyId) => {
        setIsLoading(true);
        API_SERVICE.updateCaseCWOfferDetails(leadData?.caseDetails?.caseId, journeyId)
            .then(({ data }) => {
                notification.success({ message: data?.payload })
            }).catch((e: any) => {
                notification.error({ message: API_SERVICE?.handleErrors(e) })
            })
            .finally(() => setIsLoading(false));
    }

    const renderLogin = (tmpFindData) => {
        return <Login
        setIsLoading={setIsLoading}
        leadData={leadData}
        updateCase={updateCase}
        getRedirectURLLink={getRedirectURLLink}
        getCashETriggerSMSLink={getCashETriggerSMSLink}
        callbackReqDoc={callbackReqDoc}
        callbackAdditionalField={callbackAdditionalField}
        setShowRequirementDocs={setShowRequirementDocs}
        setSelectedLander={setSelectedLander}
        setAdditionalFields={setAdditionalFields}
        setCurrLenderId={setCurrLenderId}
        setCurrLeadId={setCurrLeadId}
        setShowAdditionalFields={setShowAdditionalFields}
        submitTask={submitTask}
        getTaskData={getTaskData}
        getLenderAdditonalField={getLenderAdditonalField}
        lenderNextHandler={lenderNextHandler}
        loading={loading}
        getNextTask={getNextTask}
        setCallbackReqDoc={setCallbackReqDoc}
        decisionData={listData(tmpFindData?.decisioningDataListResponseList ?? [], lendersData)} 
        getLenders={getLenders}
        setProductPlanName={setProductPlanName}
        productPlanName={productPlanName}
        setProductPlanId={setProductPlanId}
        productPlanId={productPlanId}
        lenderListInsurer={lenderListInsurer}
        selectedLender={selectedLender}
        setSelectedLender={setSelectedLender}
        annualFee={annualFee}
        setAnnualFee={setAnnualFee}
       
    />
    }

    return (
        <>
            {leadData?.loanType==="Credit Card" 
            ? renderLogin({}) 
            : 
            <Tabs
                className="lender-sub-tabs"
                style={{'--borderColor': appColors?.appPrimaryColor ?? ""}as any}
                size="small"
                activeKey={loginTabkey}
                onChange={(key) => { setLoginTabkey(key); setIsLoginTabsListDecisioning(true) }}
            >
                {leadData?.journeyConfigResponseList?.map((data: any) => {
                    let tmpFindData = descisioningDetail?.find((item: any) =>
                        item?.journeyId == data?.journeyId
                    );
                    return (
                        <Tabs.TabPane
                            key={data?.journeyId}
                            tab={data?.journeyName}
                        >                            
                            {renderLogin(tmpFindData)}
                        </Tabs.TabPane>
                    )
                })}
            </Tabs>
            }
        </>
    )
}

export default LoginTabs;